import styles from './notification_list_item.module.scss';
import {classNames} from '../../support/classnames.ts';
import {Icon} from '../icon/icon.tsx';
export function NotificationListItemsPlaceholder() {
    return [0, 1, 2].map((key) => (
        <div
            key={key}
            className={classNames(styles.notification_list_item, styles.notification_list_item_placeholder, {
                [styles.second]: key === 1,
                [styles.third]: key === 2,
            })}
        >
            <div className={styles.item_icon}>
                <Icon iconClassName="fa-light" />
            </div>
            <div className={styles.item_content}>
                <div className={styles.content_title}>
                    <span className={styles.placeholder}></span>
                </div>
                <div className={styles.content_message}>
                    <span className={styles.placeholder}></span>
                </div>
            </div>
        </div>
    ));
}
